// source: stailer/externaladminrpc/external_admin_auth_option.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_descriptor_pb = require('google-protobuf/google/protobuf/descriptor_pb.js');
goog.object.extend(proto, google_protobuf_descriptor_pb);
var stailer_externaladminrpc_external_admin_user_pb = require('../../stailer/externaladminrpc/external_admin_user_pb.js');
goog.object.extend(proto, stailer_externaladminrpc_external_admin_user_pb);
goog.exportSymbol('proto.stailer_external_admin.ExternalAdminAuth', null, global);
goog.exportSymbol('proto.stailer_external_admin.RestrictToAssignedShop', null, global);
goog.exportSymbol('proto.stailer_external_admin.RestrictionApplicableRole', null, global);
goog.exportSymbol('proto.stailer_external_admin.externalAdminAuth', null, global);
goog.exportSymbol('proto.stailer_external_admin.restrictToAssignedShop', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.ExternalAdminAuth = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stailer_external_admin.ExternalAdminAuth.repeatedFields_, null);
};
goog.inherits(proto.stailer_external_admin.ExternalAdminAuth, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.ExternalAdminAuth.displayName = 'proto.stailer_external_admin.ExternalAdminAuth';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.RestrictToAssignedShop = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stailer_external_admin.RestrictToAssignedShop.repeatedFields_, null);
};
goog.inherits(proto.stailer_external_admin.RestrictToAssignedShop, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.RestrictToAssignedShop.displayName = 'proto.stailer_external_admin.RestrictToAssignedShop';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stailer_external_admin.ExternalAdminAuth.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.ExternalAdminAuth.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.ExternalAdminAuth.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.ExternalAdminAuth} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ExternalAdminAuth.toObject = function(includeInstance, msg) {
  var f, obj = {
    allowedRolesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of ExternalAdminAuth as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.ExternalAdminAuth.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.allowedRolesList;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.ExternalAdminAuth.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.ExternalAdminAuth}
 */
proto.stailer_external_admin.ExternalAdminAuth.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.ExternalAdminAuth();
  obj.allowedRolesList != null && jspb.Message.setField(msg, 1, obj.allowedRolesList);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.ExternalAdminAuth}
 */
proto.stailer_external_admin.ExternalAdminAuth.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.ExternalAdminAuth;
  return proto.stailer_external_admin.ExternalAdminAuth.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.ExternalAdminAuth} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.ExternalAdminAuth}
 */
proto.stailer_external_admin.ExternalAdminAuth.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.stailer_external_admin.ExternalAdminUser.Role>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAllowedRoles(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.ExternalAdminAuth.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.ExternalAdminAuth.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.ExternalAdminAuth} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ExternalAdminAuth.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAllowedRolesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
};


/**
 * repeated ExternalAdminUser.Role allowed_roles = 1;
 * @return {!Array<!proto.stailer_external_admin.ExternalAdminUser.Role>}
 */
proto.stailer_external_admin.ExternalAdminAuth.prototype.getAllowedRolesList = function() {
  return /** @type {!Array<!proto.stailer_external_admin.ExternalAdminUser.Role>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.stailer_external_admin.ExternalAdminUser.Role>} value
 * @return {!proto.stailer_external_admin.ExternalAdminAuth} returns this
 */
proto.stailer_external_admin.ExternalAdminAuth.prototype.setAllowedRolesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.stailer_external_admin.ExternalAdminUser.Role} value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.ExternalAdminAuth} returns this
 */
proto.stailer_external_admin.ExternalAdminAuth.prototype.addAllowedRoles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.ExternalAdminAuth} returns this
 */
proto.stailer_external_admin.ExternalAdminAuth.prototype.clearAllowedRolesList = function() {
  return this.setAllowedRolesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stailer_external_admin.RestrictToAssignedShop.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.RestrictToAssignedShop.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.RestrictToAssignedShop.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.RestrictToAssignedShop} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.RestrictToAssignedShop.toObject = function(includeInstance, msg) {
  var f, obj = {
    restrictedRolesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of RestrictToAssignedShop as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.RestrictToAssignedShop.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.restrictedRolesList;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.RestrictToAssignedShop.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.RestrictToAssignedShop}
 */
proto.stailer_external_admin.RestrictToAssignedShop.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.RestrictToAssignedShop();
  obj.restrictedRolesList != null && jspb.Message.setField(msg, 1, obj.restrictedRolesList);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.RestrictToAssignedShop}
 */
proto.stailer_external_admin.RestrictToAssignedShop.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.RestrictToAssignedShop;
  return proto.stailer_external_admin.RestrictToAssignedShop.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.RestrictToAssignedShop} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.RestrictToAssignedShop}
 */
proto.stailer_external_admin.RestrictToAssignedShop.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.stailer_external_admin.RestrictionApplicableRole>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRestrictedRoles(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.RestrictToAssignedShop.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.RestrictToAssignedShop.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.RestrictToAssignedShop} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.RestrictToAssignedShop.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRestrictedRolesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
};


/**
 * repeated RestrictionApplicableRole restricted_roles = 1;
 * @return {!Array<!proto.stailer_external_admin.RestrictionApplicableRole>}
 */
proto.stailer_external_admin.RestrictToAssignedShop.prototype.getRestrictedRolesList = function() {
  return /** @type {!Array<!proto.stailer_external_admin.RestrictionApplicableRole>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.stailer_external_admin.RestrictionApplicableRole>} value
 * @return {!proto.stailer_external_admin.RestrictToAssignedShop} returns this
 */
proto.stailer_external_admin.RestrictToAssignedShop.prototype.setRestrictedRolesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.stailer_external_admin.RestrictionApplicableRole} value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.RestrictToAssignedShop} returns this
 */
proto.stailer_external_admin.RestrictToAssignedShop.prototype.addRestrictedRoles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.RestrictToAssignedShop} returns this
 */
proto.stailer_external_admin.RestrictToAssignedShop.prototype.clearRestrictedRolesList = function() {
  return this.setRestrictedRolesList([]);
};


/**
 * @enum {number}
 */
proto.stailer_external_admin.RestrictionApplicableRole = {
  RESTRICTION_APPLICABLE_ROLE_UNSPECIFIED: 0,
  RESTRICTION_APPLICABLE_ROLE_MEMBER: 1
};


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `externalAdminAuth`.
 * @type {!jspb.ExtensionFieldInfo<!proto.stailer_external_admin.ExternalAdminAuth>}
 */
proto.stailer_external_admin.externalAdminAuth = new jspb.ExtensionFieldInfo(
    50001,
    {externalAdminAuth: 0},
    proto.stailer_external_admin.ExternalAdminAuth,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         proto.stailer_external_admin.ExternalAdminAuth.toObject),
    0);

google_protobuf_descriptor_pb.MethodOptions.extensionsBinary[50001] = new jspb.ExtensionFieldBinaryInfo(
    proto.stailer_external_admin.externalAdminAuth,
    jspb.BinaryReader.prototype.readMessage,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.stailer_external_admin.ExternalAdminAuth.serializeBinaryToWriter,
    proto.stailer_external_admin.ExternalAdminAuth.deserializeBinaryFromReader,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.MethodOptions.extensions[50001] = proto.stailer_external_admin.externalAdminAuth;


/**
 * A tuple of {field number, class constructor} for the extension
 * field named `restrictToAssignedShop`.
 * @type {!jspb.ExtensionFieldInfo<!proto.stailer_external_admin.RestrictToAssignedShop>}
 */
proto.stailer_external_admin.restrictToAssignedShop = new jspb.ExtensionFieldInfo(
    50002,
    {restrictToAssignedShop: 0},
    proto.stailer_external_admin.RestrictToAssignedShop,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         proto.stailer_external_admin.RestrictToAssignedShop.toObject),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[50002] = new jspb.ExtensionFieldBinaryInfo(
    proto.stailer_external_admin.restrictToAssignedShop,
    jspb.BinaryReader.prototype.readMessage,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.stailer_external_admin.RestrictToAssignedShop.serializeBinaryToWriter,
    proto.stailer_external_admin.RestrictToAssignedShop.deserializeBinaryFromReader,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[50002] = proto.stailer_external_admin.restrictToAssignedShop;

goog.object.extend(exports, proto.stailer_external_admin);
